export default __webpack_public_path__ + "static/circle-shape2-943eced582aa86510f8d0ff797800288.png";